import styles from "../landing-page-four.module.css";
import { CTAButton } from "BEDROCK/shared-components/cta-button";

interface EndSectionProps {
  onClickCTA: () => void;
}

export const EndSection = (props: EndSectionProps) => {
  return (
    <div className={styles.sectionContainer}>
      <div className={styles.endSectionContainer}>
        <h2 className={styles.endSectionTitle}>
          The Perfect Gift for Your Runner or Hiker
        </h2>
        <p className={styles.endSectionSubtitle}>
          Create your custom art print in minutes
        </p>
        <CTAButton title="BROWSE PRESET DESIGNS" onClick={props.onClickCTA} />
      </div>
    </div>
  );
};
